module.exports = __webpack_public_path__ + "img/sp-logo.85141109.svg";